import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="border-t bg-background px-4 py-5 text-center text-xs text-muted-foreground">
      <div className="mb-2">&copy; {new Date().getFullYear()} Retreevo, Inc. All rights reserved.</div>
      <Link to="/privacy-policy" className="hover:text-foreground hover:underline">
        Privacy
      </Link>
      <span className="mx-1">&middot;</span>
      <Link to="/terms-of-use" className="hover:text-foreground hover:underline">
        Terms
      </Link>
      <span className="mx-1">&middot;</span>
      <Link to="/faq" className="hover:text-foreground hover:underline">
        FAQ
      </Link>
    </footer>
  );
};

Footer.propTypes = {};

export default Footer;
